// services/changeCountriesService.js
import apiClient from '@/services/apiService'

class ChangeCountriesService {
  async create(id: number, countries: number[]) {
    try {
      const response = await apiClient.post(`/exam-localization/${id}/countries`, {
        countries,
      })
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, data: error}
    }
  }
}

export default new ChangeCountriesService()
